import { IconButton, Tooltip } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { DataCellProps } from '../types';

const TeamsV2ExpandToggleCell = ({ team, _customRowProps }: DataCellProps) => {
  const { expandedIds, onToggleExpand } = _customRowProps;
  const isExpanded = expandedIds?.has(team.id);

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    onToggleExpand?.(team.id);
  };

  return (
    <Tooltip title={isExpanded ? 'Collapse' : 'Expand'}>
      <span>
        <IconButton size="small" onClick={handleClick}>
          {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default TeamsV2ExpandToggleCell;
